import React from 'react'

import { FormItem } from '@react/react-spectrum/Form'
import Heading from '@react/react-spectrum/Heading'
import Textfield from '@react/react-spectrum/Textfield'
import MediaUpload from 'components/MediaUpload'
import ColorInput from 'components/ColorInput'

export default function ({ branding, project, onChange, disabled }) {
  return (
    <>
      <section>
        <Heading size='4'>Logo</Heading>
        <MediaUpload
          type='image'
          value={branding.logo}
          heading='Drag and Drop'
          onUpload={onChange('logo')}
          projectId={project?.meta?.id}
          path={'branding-logo'}
          withTextfield={true}
          disabled={disabled}
        />
      </section>
      <div className='grid-section-container'>
        <section>
          <Heading size='4'>Main</Heading>
          <FormItem label='Primary Color'>
            <ColorInput
              placeholder='Primary Color'
              name='primaryColor'
              value={branding.primaryColor}
              onChange={onChange('primaryColor')}
              disabled={disabled}
            />
          </FormItem>
          <FormItem label='Text Color'>
            <ColorInput
              placeholder='Text Color'
              name='mainTextColor'
              value={branding.mainTextColor}
              onChange={onChange('mainTextColor')}
              disabled={disabled}
            />
          </FormItem>
          <FormItem label='Background Color'>
            <ColorInput
              placeholder='Background Color'
              name='mainBackgroundColor'
              value={branding.mainBackgroundColor}
              onChange={onChange('mainBackgroundColor')}
              disabled={disabled}
            />
          </FormItem>
          <FormItem label='Font'>
            <Textfield
              placeholder='Font'
              name='bodyFont'
              value={branding.bodyFont}
              onChange={onChange('bodyFont')}
              disabled={true}
            />
          </FormItem>
        </section>
        <section>
          <Heading size='4'>Header</Heading>
          <FormItem label='Text Color'>
            <ColorInput
              placeholder='Text Color'
              name='headerTextColor'
              value={branding.headerTextColor}
              onChange={onChange('headerTextColor')}
              disabled={disabled}
            />
          </FormItem>
          <FormItem label='Background Color'>
            <ColorInput
              placeholder='Background Color'
              name='headerBackgroundColor'
              value={branding.headerBackgroundColor}
              onChange={onChange('headerBackgroundColor')}
              disabled={disabled}
            />
          </FormItem>
        </section>
        <section>
          <Heading size='4'>Modules</Heading>
          <FormItem label='Text Color'>
            <ColorInput
              placeholder='Text Color'
              name='modulesTextColor'
              value={branding.modulesTextColor}
              onChange={onChange('modulesTextColor')}
              disabled={disabled}
            />
          </FormItem>
          <FormItem label='Background Color'>
            <ColorInput
              placeholder='Background Color'
              name='modulesBackgroundColor'
              value={branding.modulesBackgroundColor}
              onChange={onChange('modulesBackgroundColor')}
              disabled={disabled}
            />
          </FormItem>
        </section>
        <section>
          <Heading size='4'>Sidebars</Heading>
          <FormItem label='Text Color'>
            <ColorInput
              placeholder='Text Color'
              name='sidebarsTextColor'
              value={branding.sidebarsTextColor}
              onChange={onChange('sidebarsTextColor')}
              disabled={disabled}
            />
          </FormItem>
          <FormItem label='Background Color'>
            <ColorInput
              placeholder='Background Color'
              name='sidebarsBackgroundColor'
              value={branding.sidebarsBackgroundColor}
              onChange={onChange('sidebarsBackgroundColor')}
              disabled={disabled}
            />
          </FormItem>
        </section>
      </div>
    </>
  )
}
